import { ClientValidationOperator } from "../config/ClientValidationOperator";
import { ValidationRule } from "./ValidationRule";

export {
  ValidationRuleSet,
  validationRuleSetToValidationRules,
  validationRulesToValidationRuleSet,
  setupRulesets,
};

type ValidationRuleSet = {
  fieldName: string;
  clientValidationOperator: ClientValidationOperator;
  validationRules: ValidationRule[];
};

const validationRuleSetToValidationRules = (
  ruleset: ValidationRuleSet,
): ValidationRule[] => {
  return ruleset.validationRules.map((x, i) => new ValidationRule(x.toData()));
};
const validationRulesToValidationRuleSet = (
  fieldName: string,
  rules: ValidationRule[],
  operator: ClientValidationOperator,
): ValidationRuleSet => {
  return {
    fieldName,
    clientValidationOperator: operator,
    validationRules: rules
      .filter((x) => x.isConfigured())
      .map((x) => new ValidationRule(x.toData())),
  };
};

/**
 * setupRulests is a utility method to setup Validators on any object class
 * @param data
 * @returns
 */
function setupRulesets(data: { validators: undefined | ValidationRuleSet[] }) {
  if (data.validators == undefined && !Array.isArray(data.validators)) {
    return [];
  } else {
    return data.validators.map((x) => {
      return {
        clientValidationOperator: x.clientValidationOperator,
        fieldName: x.fieldName,
        validationRules: x.validationRules.map((x) => new ValidationRule(x)),
      };
    });
  }
}
